import {
  MDBSelect,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getMisc } from "../../../apiclients/streamsapi_bridge";

const MobileCallAssignments = ({
  setValue,
  useragent,
  mobilecallpref,
  callAssignment,
  setCallAssignment,
  sid,
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [preone, setPreOne] = useState(-1);
  const [pretwo, setPreTwo] = useState(-1);
  const [prethree, setPreThree] = useState(-1);
  const [prefour, setPreFour] = useState(-1);

    useEffect(() => {
    if (mobilecallpref) {
      setPreOne(mobilecallpref.one);
      setPreTwo(mobilecallpref.two);
      setPreThree(mobilecallpref.three);
      setPreFour(mobilecallpref.four);
    }
  }, [mobilecallpref]);

  async function fetchCallAssignment() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["mobile_call_pref"], agentid: useragent }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    let callassign = tdata.misc.mobile_call_pref ?? [];
    callassign = Object.entries(callassign)?.map(([key, value]) => ({
      value: parseInt(value),
      text: key,
    }));
    setCallAssignment(callassign);
 
  }

    useEffect(() => {
        if (useragent !== "") {
            fetchCallAssignment();
        }
    }, [useragent]);


    return (
        <>
            <div className="general-settings">
                {t("Mobile Call Assignments")}
            </div>
            <div className="ps-0">
                {/* Arrangement of order according to Jerome's Enhancements suggested changes */}
                {sid !== "COMMONSEAT" && (
                    <>
                        <div className="mt-2" style={{ paddingLeft: "7px", paddingRight: "10px" }}>
                            <MDBTable>
                                <MDBTableHead>
                                    <tr>
                                        <th scope="col" className="w-80">
                                            {t("Assignment")}
                                        </th>
                                        <th scope="col" className="w-30">
                                            {t("Destination")}
                                        </th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    <tr>
                                        <th scope="row">* 1</th>
                                        <td>
                                            <MDBSelect
                                                className="w-100"
                                                name="San Jose"
                                                value={preone}
                                                data={[
                                                    { text: "Select Destination", value: -1 },
                                                    ...(Array.isArray(callAssignment) ? callAssignment : []),
                                                ]}
                                                onChange={(e) => {
                                                    if (e && e.value) {
                                                        // e.preventDefault();
                                                        setValue("mobile_call_pref.one", parseInt(e.value), {
                                                            shouldDirty: true,
                                                        });
                                                        setPreOne(parseInt(e.value));
                                                    }
                                                }}
                                            />
                                            {/* <option key={-1} value={-1}>
                    --None--
                  </option>
                  {callAssignment &&
                    Object.entries(callAssignment).map(([key, value]) => (
                      <option key={key} value={key}>
                        {value}
                      </option>
                    ))}
                </MDBSelect> */}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">* 2</th>
                                        <td>
                                            <MDBSelect
                                                className="w-100"
                                                name="San Jose"
                                                data={[
                                                    { text: "Select Destination", value: -1 },
                                                    ...(Array.isArray(callAssignment) ? callAssignment : []),
                                                ]}
                                                value={pretwo}
                                                onChange={(e) => {
                                                    if (e && e.value) {
                                                        // e.preventDefault();
                                                        setValue("mobile_call_pref.two", parseInt(e.value), {
                                                            shouldDirty: true,
                                                        });
                                                        setPreTwo(parseInt(e.value));
                                                    }
                                                }}
                                            />
                                            {/* <option key={-1} value={-1}>
                    --None--
                  </option>
                  {callAssignment &&
                    Object.entries(callAssignment).map(([key, value]) => (
                      <option key={key} value={key}>
                        {value}
                      </option>
                    ))}
                </MDBSelect> */}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">* 3</th>
                                        <td>
                                            <MDBSelect
                                                className="w-100"
                                                name="San Jose"
                                                value={prethree}
                                                data={[
                                                    { text: "Select Destination", value: -1 },
                                                    ...(Array.isArray(callAssignment) ? callAssignment : []),
                                                ]}
                                                onChange={(e) => {
                                                    if (e && e.value) {
                                                        // e.preventDefault();
                                                        setValue("mobile_call_pref.three", parseInt(e.value), {
                                                            shouldDirty: true,
                                                        });
                                                        setPreThree(parseInt(e.value));
                                                    }
                                                }}
                                            />
                                            {/* <option key={-1} value={-1}>
                    --None--
                  </option>
                  {callAssignment &&
                    Object.entries(callAssignment).map(([key, value]) => (
                      <option key={key} value={key}>
                        {value}
                      </option>
                    ))}
                </MDBSelect> */}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">* 4</th>
                                        <td>
                                            <MDBSelect
                                                className="w-100"
                                                name="San Jose"
                                                value={prefour}
                                                data={[
                                                    { text: "Select Destination", value: -1 },
                                                    ...(Array.isArray(callAssignment) ? callAssignment : []),
                                                ]}
                                                onChange={(e) => {
                                                    if (e && e.value) {
                                                        // e.preventDefault();
                                                        setValue("mobile_call_pref.four", parseInt(e.value), {
                                                            shouldDirty: true,
                                                        });
                                                        setPreFour(parseInt(e.value));
                                                    }
                                                }}
                                            />
                                            {/* <option key={-1} value={-1}>
                    --None--
                  </option>
                  {callAssignment &&
                    Object.entries(callAssignment).map(([key, value]) => (
                      <option key={key} value={key}>
                        {value}
                      </option>
                    ))}
                </MDBSelect> */}
                                        </td>
                                    </tr>
                                </MDBTableBody>
                            </MDBTable>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};
export default MobileCallAssignments;
